import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useApuracaoSN } from '@/contexts';
import { ExportarEspelhoButton } from './ExportarEspelhoButton';

export function MemoriaCalculo() {
  const { dados } = useApuracaoSN();

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="text-base font-semibold">Memória de Cálculo</CardTitle>
            <p className="text-xs text-muted-foreground mt-0.5">Detalhamento do cálculo do DAS</p>
          </div>
          <ExportarEspelhoButton />
        </div>
      </CardHeader>
      <CardContent className="space-y-0 p-0">
        {dados.memoriaCalculo.map((item, i) => (
          <div
            key={i}
            className="flex items-center justify-between px-6 py-4 border-b last:border-0"
          >
            <div className="space-y-0.5">
              <p className="text-sm font-medium">{item.label}</p>
              {item.formula && (
                <p className="text-xs text-muted-foreground">Fórmula: {item.formula}</p>
              )}
            </div>
            <span className="text-sm font-semibold tabular-nums">{item.valor}</span>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
